export default "__VITE_ASSET__vpcVhV4z__"